import { GRAY_4, GRAY_2, GRAY_8, TRIMBLE_GRAY, WHITE } from './mc-tokens';

export const MODUS_DROPDOWN_MENU_STYLESHEET = `
.tc-modus-dropdown-trigger {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  max-width: 100%;
}
.tc-modus-dropdown-trigger-label {
  flex: 0 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.25;
}
.tc-modus-dropdown-trigger > :not(.tc-modus-dropdown-trigger-label) {
  flex-shrink: 0;
}
modus-wc-dropdown-menu.modus-wc-dropdown-menu {
  background-color: transparent !important;
}
modus-wc-dropdown-menu modus-wc-button button.modus-wc-btn {
  min-height: 2.5rem;
  min-width: 2.5rem;
  padding: 0.5rem;
  border: none;
  border-radius: 0.125rem;
  color: ${GRAY_8} !important;
}
modus-wc-dropdown-menu:has(.tc-modus-dropdown-trigger),
modus-wc-dropdown-menu:has(.tc-modus-dropdown-trigger) modus-wc-button,
modus-wc-dropdown-menu:has(.tc-modus-dropdown-trigger) button.modus-wc-btn {
  min-width: 0;
  max-width: 100%;
}
modus-wc-dropdown-menu modus-wc-button:not([aria-expanded="true"]) button.modus-wc-btn {
  background-color: transparent !important;
}
modus-wc-dropdown-menu modus-wc-button:not([aria-expanded="true"]) button.modus-wc-btn:hover:not(:disabled)  {
 background-color: var(--modus-wc-color-base-100) !important;
}

modus-wc-dropdown-menu modus-wc-button .modus-wc-btn[disabled],
modus-wc-dropdown-menu modus-wc-button .modus-wc-btn.modus-wc-btn-disabled {
  pointer-events: inherit !important;
  
}
modus-wc-dropdown-menu modus-wc-button[aria-expanded="true"] button.modus-wc-btn {
  background-color: ${GRAY_2}!important;
  border-color: ${GRAY_2} !important;
}
modus-wc-dropdown-menu modus-wc-icon:not(:defined) {
  display: inline-block;
  width: 1.5rem;
  height: 1.5rem;
  overflow: hidden;
  color: transparent;
  font-size: 0;
  line-height: 0;
}
modus-wc-dropdown-menu .menu-wrapper {
  box-shadow: 0 0 0.375rem ${GRAY_4};
  border-radius: 0.125rem;
  background-color: ${WHITE};
  max-height: 21.5rem;
  overflow-y: auto;
}
modus-wc-dropdown-menu modus-wc-menu .modus-wc-menu {
  padding: 1rem 0 !important;
}
modus-wc-dropdown-menu modus-wc-menu-item .modus-wc-menu-item {
  height: 2.5rem;
  min-height: 2.5rem;
  & button:active {
    background-color: transparent !important;
  }
}
modus-wc-dropdown-menu modus-wc-menu-item button {
  padding: 0.5rem 0.5rem;!important;
  font-size: 0.875rem;
  color: ${TRIMBLE_GRAY} !important;
}
modus-wc-dropdown-menu modus-wc-menu-item .modus-wc-menu-item.modus-wc-menu-item-active,
modus-wc-dropdown-menu modus-wc-menu-item .modus-wc-menu-item.modus-wc-menu-item-selected {
  background-color: #cfe1ee !important;
  font-weight: 600 !important;
  button {
    color: var(--modus-wc-color-primary) !important;
  }
}
`;
